export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9455.80d044ea.jpg";